export abstract class LanguageService {
    readonly SUPPORTED_LANGUAGES: string[] = ['fr', 'de'];

    public abstract getLanguage(defaultLanguage: string): string;
}
